export default "/assets/images/list-icon4.svg?5705977f91803c5b792ddfbde3b88a9a";